import React, { useRef } from 'react';

import { bemCssModules, getTestId } from '@utils';
import { useModal } from '@utils/hooks';

import { Tooltip } from '@components/Tooltip';

import Question from './icons/question.svg';

import style from './QuestionButton.scss';

const cn = bemCssModules(style, 'QuestionButton');
const ti = getTestId('QuestionButton');

export type TQuestionButton = {
  className?: string;
  tooltipContent?: React.ReactNode;
};

export const QuestionButton: React.FC<TQuestionButton> = props => {
  const { tooltipContent, className } = props;

  if (!tooltipContent) return null;

  const buttonRef = useRef<HTMLButtonElement>(null);
  const [isOpen, setIsOpen, tooltipRef] = useModal([buttonRef]);

  const onClick = () => setIsOpen(!isOpen);

  return (
    <div data-testid={ti()} className={cn(null, [className])}>
      <button className={cn('tooltip-button')} ref={buttonRef} type="button" onClick={onClick}>
        <Question className={cn('icon')} />
      </button>
      <Tooltip className={cn('tooltip')} ref={tooltipRef} isOpen={isOpen}>
        {tooltipContent}
      </Tooltip>
    </div>
  );
};

export default QuestionButton;
